import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

export function HeroSection() {
  const { t } = useTranslation('common')

  return (
    <section className="relative w-full h-[70vh] min-h-[500px] max-h-[800px] flex items-end overflow-hidden bg-[#2A0E0E]">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/images/news_iniziative.png"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2A0E0E] via-[#2A0E0E]/50 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#2A0E0E]/70 via-transparent to-transparent" />
      </div>

      {/* Grain */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04] z-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Content */}
      <div className="relative z-20 mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8 pb-24 pt-40">
        <div className="max-w-2xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#DF631E]" />
              <span className="text-xs font-semibold uppercase tracking-[0.25em] text-[#DF631E]">
                {t('nav.news')}
              </span>
            </div>

            <h1
              className="text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.05] mb-5"
              style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
            >
              {t('news.hero.title')}
            </h1>

            <p className="text-base md:text-lg text-white/60 max-w-lg leading-relaxed">
              {t('news.hero.subtitle')}
            </p>
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-[#FDF8F3] to-transparent z-20" />
    </section>
  )
}
